import {RequestAPI} from './FetchAPI';

const BASE_URL = 'https://api.airtable.com';
const STAGE = '/v0/appD21MSWdslJlKf0';
const TABLE = 'ContentProjects';
const { REACT_APP_AIRTABLE_API_KEY } = process.env

function createFetchInstance() {
  return new RequestAPI(`${BASE_URL}${STAGE}/${TABLE}`, {
    Authorization: `Bearer ${REACT_APP_AIRTABLE_API_KEY}`,
  });
}

export function getFetchWidgetDocumentRequest() {
  const request = createFetchInstance();
  return request.get;
}
